import React from 'react';
import { alphabeticallySort } from '../../../../utilities/helperUtility';
import { stringToBoolean } from '../../../../utilities/conversionUtility';
import Select from '../../../../components/Common/Select';
import ComponentSelect from '../ComponentSelect';
import ErrorTooltip from '../../ErrorTooltip';

export default class ResourceSelect extends ComponentSelect {
  componentDidUpdate(oldProps) {
    const {
      resources,
      selectedResource,
      selectedLocation: newLocation,
    } = this.props;
    const { setSelected, selectedLocation: oldLocation } = oldProps;
    const locations = selectedResource ? selectedResource.locations : [];
    const newLocationId = newLocation ? newLocation.id : null;
    const oldLocationId = oldLocation ? oldLocation.id : null;
    const isLocationChanged = newLocationId !== oldLocationId;

    if (
      (!resources && selectedResource != null)
      || (isLocationChanged && locations.length > 0 && !locations.includes(newLocationId))
    ) {
      setSelected(null);
    }
  }

  validate() {
    const resourceOptions = this.resourceOptions();
    const errors = [];

    if (!resourceOptions.length) return errors;

    return super.validate();
  }

  resourceOptions() {
    const { resources, selectedLocation, setting } = this.props;
    const resourcesTypes = [];
    const options = [];

    if (stringToBoolean(setting.staff_resources)) {
      resourcesTypes.push('Staff');
    }
    if (stringToBoolean(setting.equipment_resources)) {
      resourcesTypes.push('Equipment');
    }
    if (stringToBoolean(setting.room_resources)) {
      resourcesTypes.push('Room');
    }

    alphabeticallySort(resources, 'name').map(({
      id, locations, name, resource_type,
    }) => {
      if (
        resourcesTypes.includes(resource_type)
        && (!selectedLocation || locations.length === 0 || locations.includes(selectedLocation.id))
      ) {
        options.push({
          label: name,
          value: id,
        });
      }
    });

    return options;
  }

  render() {
    const {
      bookingToken,
      errors,
      errorMessage,
      isDisabled,
      label,
      selectedResource,
      styles,
      style = {},
      kind,
      className,
    } = this.props;
    const resourceOptions = this.resourceOptions();
    const selectedResourceId = selectedResource ? selectedResource.id : null;

    if (!resourceOptions.length || bookingToken) return null;

    return (
      <div className="select-block resources-select">
        <span className="titles" style={{ ...style }}>
          {label}
        </span>
        <div style={{ position: 'relative' }}>
          <Select
            placeholder={this.placeholder()}
            styles={styles}
            className={className}
            name={kind}
            value={selectedResourceId}
            options={resourceOptions}
            isClearable
            isDisabled={isDisabled}
            disableResetToPrev
            isSearchable={false}
            allowSelectOption
            onChange={this.onChange}
          />
          {errors && <ErrorTooltip message={errorMessage} />}
        </div>
      </div>
    );
  }
}
